'use client';

import { localStorageColorSchemeManager, MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import type { ReactNode } from 'react';
import { theme } from '../lib/theme';
import '@mantine/notifications/styles.css';
// NOTE (FE-STEP-1 deviation from contract §3.7.2): `@mantine/modals@9.x` does NOT ship
// `styles.css` — its package `exports` map exposes only `.`, and the package reuses
// `@mantine/core`'s `Modal`/`ConfirmModal` styles (already loaded via MantineProvider CSS).
// The contract line `import '@mantine/modals/styles.css';` would break `next build`
// (Module not found). See implementation-frontend.md → "Отклонения от контракта".

const colorSchemeManager = localStorageColorSchemeManager({
  key: 'seentra-color-scheme',
});

export function Providers({ children }: { children: ReactNode }) {
  return (
    <MantineProvider
      theme={theme}
      defaultColorScheme="dark"
      colorSchemeManager={colorSchemeManager}
    >
      <ModalsProvider>
        <Notifications position="top-right" />
        {children}
      </ModalsProvider>
    </MantineProvider>
  );
}
